import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography } from '@mui/material';
import { getCsrfToken } from '../utils/cookies';
import { cardLgSx, fieldSx, primaryButtonSx } from './pvtaStyles';

const EmailResetForm: React.FC = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [emailError, setEmailError] = useState('');

    // Eine einfache Regex-Prüfung für E-Mail-Adressen
    const validateEmail = (email: string): boolean => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        // Prüfe, ob die eingegebene E-Mail gültig ist
        if (!validateEmail(email)) {
            setEmailError('Bitte eine gültige E-Mail-Adresse eingeben.');
            return;
        } else {
            setEmailError('');
        }

        const csrfToken = getCsrfToken();
        const response = await fetch('/api/password-reset/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify({ email }),
        });
        const data = await response.json();
        setMessage(data.detail);
    };

    return (
        <Box
            sx={{
                p: 2,
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'linear-gradient(160deg, var(--pvta-bg) 0%, var(--pvta-green-100) 100%)',
            }}
        >
                <Paper
                    elevation={0}
                    sx={{ ...cardLgSx, p: { xs: 3, sm: 4 }, width: '100%', maxWidth: 420, boxSizing: 'border-box' }}
                >
                    <Box display="flex" justifyContent="center" mb={2}>
                        <img
                            src="/Wappen_PVTA.png"
                            alt="Logo"
                            style={{ maxWidth: '100%', height: 'auto' }}
                        />
                    </Box>
                    <Typography
                        align="center"
                        sx={{
                            fontFamily: 'Georgia, "Times New Roman", serif',
                            fontWeight: 700,
                            fontSize: 26,
                            color: 'var(--pvta-green-900)',
                            mb: 0.5,
                        }}
                    >
                        Passwort zurücksetzen
                    </Typography>
                    <Typography variant="body2" align="center" sx={{ color: 'var(--pvta-muted)', mb: 2 }}>
                        Wir senden dir einen Link zum Zurücksetzen an deine E-Mail.
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="Deine E-Mail"
                            type="email"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            size="small"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            error={!!emailError}
                            helperText={emailError}
                            sx={{ ...fieldSx }}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            sx={{ ...primaryButtonSx, mt: 2 }}
                        >
                            Passwort zurücksetzen
                        </Button>
                        {message && (
                            <Typography
                                variant="body2"
                                align="center"
                                color="textSecondary"
                                sx={{ mt: 2 }}
                            >
                                {message}
                            </Typography>
                        )}
                    </form>
                </Paper>
        </Box>
    );
};

export default EmailResetForm;
